import { ColumnsType } from 'antd/lib/table'
import ColorProofNumber from '../../../../../components/color-proof-number/color-proof-number'
import { renderShipmentCalculatedValue } from '../../../../../components/shipment-calculated-value/render-shipment-calculated-value'
import formatMachineBrands from '../../../../../helpers/calculations/formatters/format-machine-brands'
import renderDate from '../../../../../helpers/tables/render-date'
import { MaterialRequirement } from '../../../../../types/api/components/material/material-requirements'
import ShipmentPosition from '../../../../../types/api/shipment-position'
import ActionsCell from './components/actions-cell'
import { CreatedPrintJobsTab } from './types'
import formatNumber from '../../../../../helpers/formatters/format-any-number'
import { createAvailabilityColumns } from '../../constants/availability-columns'
import {
    createStampTubeColumn,
    printJobFormSetIdColumn,
    additionalJobs,
    tsAndLm,
    createAdditionalInfoColumn,
    createCuratorPrintColumn,
} from '../../constants/columns'
import PrintJob from '../../../../../types/api/print-job'
import { MaterialColumnCell } from '../cells/material-column-cell'
import PrintJobNoteCell from '../cells/print-job-note-cell'
import ShipmentTimeCell from '../cells/shipment-time-cell'
import { formatRollerDisplay } from '../../../../../helpers/format-roller-display'
import { RotatedTitle } from '../../../../../components/rotated-title/rotated-title'

export const getColumns = (
    tab: CreatedPrintJobsTab,
    canEdit: boolean
): ColumnsType<PrintJob> => [
    {
        dataIndex: ['shipment', 'id'],
        title: 'Номер отгрузки',
        width: 68,
        render: (id, record: PrintJob) => (
            <ColorProofNumber shipmentType={record.shipment?.shipmentType}>{id}</ColorProofNumber>
        ),
    },
    {
        dataIndex: ['shipment', 'clientDeliveryDate'],
        title: 'Дата поставки',
        width: 70,
        render: renderDate,
    },
    {
        dataIndex: ['shipment', 'client', 'name'],
        title: 'Клиент',
    },
    createAdditionalInfoColumn<PrintJob>(record => record.shipment),
    {
        dataIndex: ['shipment', 'shipment_positions'],
        title: 'Тираж',
        render(v: ShipmentPosition[]) {
            return formatNumber(v.reduce((acc, v) => acc + v.copies, 0))
        },
    },
    {
        dataIndex: ['shipment', 'materialRequirements'],
        title: 'Материал',
        width: 100,
        render(v: MaterialRequirement[], record) {
            return <MaterialColumnCell value={v} shipment={record.shipment} />
        },
    },
    tsAndLm,
    createCuratorPrintColumn<PrintJob>(record => record.shipment),
    {
        dataIndex: ['shipment', 'calculated', 'materialLength'],
        title: 'Метраж',
        width: 60,
        render(_v, r: PrintJob) {
            return renderShipmentCalculatedValue(r.shipment, calculated =>
                Math.round((calculated?.materialLength || 0) * 1000) / 1000
            )
        },
    },
    printJobFormSetIdColumn,
    createStampTubeColumn<PrintJob>(record => record.shipment),
    {
        dataIndex: ['shipment', 'stamp', 'roller', 'roller'],
        title: 'Вал',
        render: (v: number) => formatRollerDisplay(v),
    },
    additionalJobs,
    createAvailabilityColumns<PrintJob>(record => record.shipment),
    {
        dataIndex: ['shipment', 'calculated', 'commonTime'],
        title: <RotatedTitle>Время тиража</RotatedTitle>,
        render(_v, r) {
            return <ShipmentTimeCell shipment={r.shipment} />
        },
    },
    {
        dataIndex: ['shipment', 'machine'],
        title: 'Станки',
        render(v, r) {
            return formatMachineBrands(r.shipment!) || '—'
        },
    },
    {
        title: 'Примечание',
        width: 140,
        render(_, record) {
            return <PrintJobNoteCell printJob={record} editable={canEdit} />
        },
    },
    {
        dataIndex: 'actions',
        title: '',
        width: 56,
        fixed: 'right',
        render(v, r) {
            return <ActionsCell printJob={r} tab={tab} />
        },
    },
]
